// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-chart{display:flex;justify-content:center;flex-direction:column;align-items:center;flex:1}`, "",{"version":3,"sources":["webpack://./resources/app/modules/proposal/Blocks/ChartBlock/index.scss"],"names":[],"mappings":"AAAA,aACE,YAAA,CACA,sBAAA,CACA,qBAAA,CACA,kBAAA,CACA,MAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
